import { CircularProgress as CircularProgressMUI } from "@mui/material";
import { Fragment } from "react/jsx-runtime";

type CircularProgressProps = {
    progress: number;
    color: string;
    styleOverride?: {
        size?: string;
        thickness?: number;
    };
};
export const CircularProgress = (props: CircularProgressProps) => {
    const { progress, color, styleOverride } = props;
    const { size = "3rem", thickness = 4 } = styleOverride || {};

    const progressNormalized =
        progress > 100 ? 100
        : progress < 0 ? 0
        : progress;

    return (
        <Fragment>
            <CircularProgressMUI
                variant="determinate"
                value={100}
                size={size}
                thickness={thickness}
                sx={{
                    color: "#FFFFFF",
                    position: "absolute",
                }}
            />

            <CircularProgressMUI
                variant="determinate"
                value={progressNormalized}
                size={size}
                thickness={thickness}
                sx={{
                    color: color,
                    position: "absolute",
                    [`& .MuiCircularProgress-circle`]: {
                        strokeLinecap: "round",
                    },
                }}
            />
        </Fragment>
    );
};
